<template>
  <v-row>
    <v-col cols="12" sm="12" md="12">
      <a-text-field
        class="surveySectionTitle"
        v-model.trim="form.title"
        :placeholder="$t('title')"
        hide-details
        filled
        :label="$t('title')"
        dense
        :disabled="isSurveyExpired"
      ></a-text-field>
    </v-col>
    <v-col cols="12" sm="12" md="12">
      {{ $t("poll.lblDescription") }}:
      <div id="resize" style="border: solid 1px lightgray; padding-bottom: 1px">
        <a-rich-text-editor v-model="form.description" :editorReadonly="isSurveyExpired" @descriptionChange="descriptionChanges"></a-rich-text-editor>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import Vue from "vue";
import {
  RichTextEditorPlugin,
  Toolbar,
  Link,
  Count,
  HtmlEditor,
  QuickToolbar,
  Table,
  Resize,
} from "@syncfusion/ej2-vue-richtexteditor";
import { mapGetters } from "vuex";
Vue.use(RichTextEditorPlugin);
export default {
  name: "SurveySection",
  provide: {
    richtexteditor: [
      Toolbar,
      Link,
      Count,
      HtmlEditor,
      QuickToolbar,
      Resize,
      Table,
    ],
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    form: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || "");
      },
    },
    ...mapGetters({
      isSurveyExpired: "poll/isSurveyExpired",
    }),
  },
  methods: {
    descriptionChanges(val) {
      this.isDescriptionWithImage = val
      this.$eventHub.$emit("sectionDescriptionChange", val);
    },
    onBlur: function (e) {
      this.$refs.rteSectionObj.ej2Instances.toolbarSettings.enable = false;
    },
    onFocus: function (e) {
      this.$refs.rteSectionObj.ej2Instances.toolbarSettings.enable = true;
    },
  },
  mounted() {
    const thisInstance = this;
    setTimeout(() => {
      if (thisInstance.$refs.rteSectionObj) {
        thisInstance.$refs.rteSectionObj.refreshUI();
      }
    }, 100);
  },
};
</script>

<style scoped>
.surveySectionTitle {
  font-family: "Noto Sans JP" !important;
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 18px !important;
  min-height: 48px !important;
  max-height: 68px !important;
  color: var(--v-neutralGray-base) !important;
  align-items: center !important;
}
.surveySectionTitle > .v-input__control > .v-input__slot {
  color: var(--v-neutralGray-base) !important;
  height: 48px !important;
}
.surveySectionTitle /deep/ .v-input__slot {
  min-height: 48px !important;
}
#resize .e-richtexteditor {
  max-width: 100%;
  min-width: 100%;
  min-height: 150px;
  max-height: 300px;
}
</style>